import { render, staticRenderFns } from "./TrafficRequestChatModal.vue?vue&type=template&id=6e4000f2&scoped=true"
import script from "./TrafficRequestChatModal.vue?vue&type=script&lang=ts"
export * from "./TrafficRequestChatModal.vue?vue&type=script&lang=ts"
import style0 from "./TrafficRequestChatModal.vue?vue&type=style&index=0&id=6e4000f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4000f2",
  null
  
)

export default component.exports